// extracted by mini-css-extract-plugin
module.exports =  {"ring":"gj203hs","avatar":"fswdH6V","avatar-caption":"wLufUb4","avatarCaption":"wLufUb4"};